import { Page } from '../../../types';
import { StylesForPage } from '../styles';
import { CaptionTransitions } from '../../transitions/types';
import { LayoutType } from '@/domains/asset';
import { Word } from '@/domains/transcript';
import { isLayoutAudiogram } from '@/libs/layout';

export function createDefaultPages({
  captions,
  fps,
  stylesForPage,
  layout,
  clipDurationFrames,
  transitions
}: {
  captions: Word[];
  fps: number;
  stylesForPage: StylesForPage;
  layout: LayoutType;
  clipDurationFrames: number;
  transitions?: CaptionTransitions;
}): Page[] {
  let pages: Page[] = [];
  const isAudiogram = isLayoutAudiogram(layout);

  let tokens: Page['tokens'] = [];

  let currentPageIndex = captions[0].srt_index;

  for (let i = 0; i < captions.length; i += 1) {
    const word = captions[i];
    if (word.srt_index !== currentPageIndex) {
      if (tokens.length) {
        const fromFrame = tokens[0].fromFrame || 0;

        pages.push({
          text: word.content,
          tokens,
          fromFrame,
          toFrame: fromFrame,
          transitions,
          ...stylesForPage
        });
        tokens = [];
      }

      currentPageIndex = word.srt_index;
    }

    if (!word.hidden) {
      tokens.push({
        text: word.content,
        fromFrame: Math.ceil((word.processed_start_time || 0) * fps),
        toFrame: Math.ceil((word.processed_end_time || 0) * fps)
      });
    }
  }

  if (tokens.length) {
    const fromFrame = tokens[0].fromFrame || 0;

    pages.push({
      text: captions[captions.length - 1].content,
      tokens,
      fromFrame,
      toFrame: fromFrame,
      transitions,
      ...stylesForPage
    });
  }

  pages = pages.map((page, pageIndex) => {
    const pageText = page.tokens.map(token => token.text).join(' ');

    const nextPage = pages[pageIndex + 1] ?? null;
    const lastCaption = captions[captions.length - 1];
    const captionEndTime =
      lastCaption.processed_end_time && !isAudiogram ? lastCaption.processed_end_time * fps : clipDurationFrames;

    const toFrame = nextPage ? nextPage.fromFrame : captionEndTime;

    return {
      ...page,
      text: pageText,
      toFrame
    };
  });

  return pages;
}
